import { default as account_45managementwCZWutpaveMeta } from "/var/www/frontend/pages/account/index/account-management.vue?macro=true";
import { default as change_45passwordvkA2IxLHzoMeta } from "/var/www/frontend/pages/account/index/change-password.vue?macro=true";
import { default as danger_45zoneCuR3rMNG59Meta } from "/var/www/frontend/pages/account/index/danger-zone.vue?macro=true";
import { default as firmcP6QLPRS2dMeta } from "/var/www/frontend/pages/account/index/firm.vue?macro=true";
import { default as indexkD7KexlZSbMeta } from "/var/www/frontend/pages/account/index/index.vue?macro=true";
import { default as profileMMpqe0U411Meta } from "/var/www/frontend/pages/account/index/profile.vue?macro=true";
import { default as workHoursKjumUaHlKJMeta } from "/var/www/frontend/pages/account/index/workHours.vue?macro=true";
import { default as index0ZkXB1Z1gRMeta } from "/var/www/frontend/pages/account/index.vue?macro=true";
import { default as indexun0ZJT6vmgMeta } from "/var/www/frontend/pages/action/index.vue?macro=true";
import { default as _91id_93GijVTgukJoMeta } from "/var/www/frontend/pages/action/meeting/[id].vue?macro=true";
import { default as paymentWYnItqpIUjMeta } from "/var/www/frontend/pages/action/payment.vue?macro=true";
import { default as _91firmLawyerId_93DdWlGWAZpkMeta } from "/var/www/frontend/pages/appointment/[firmLawyerId].vue?macro=true";
import { default as _91slug_93xID1Z7kWn5Meta } from "/var/www/frontend/pages/firm/[slug].vue?macro=true";
import { default as forLawyerUXQxY0JjW9Meta } from "/var/www/frontend/pages/forLawyer.vue?macro=true";
import { default as indexV37mLHP055Meta } from "/var/www/frontend/pages/index.vue?macro=true";
import { default as _91slug_93nC1ZkJiGi0Meta } from "/var/www/frontend/pages/lawyer/[slug].vue?macro=true";
import { default as _91firmLawyerId_93IHLdonP7oEMeta } from "/var/www/frontend/pages/lawyerCalendar/[firmLawyerId].vue?macro=true";
import { default as _91specialty_93FHDDcZD7Y6Meta } from "/var/www/frontend/pages/lawyers/[specialty].vue?macro=true";
import { default as _91id_93hRb0Ju4hQaMeta } from "/var/www/frontend/pages/leaveReview/[id].vue?macro=true";
import { default as loginPqE5t9melpMeta } from "/var/www/frontend/pages/login.vue?macro=true";
import { default as maintenanceFdVXnnEBbQMeta } from "/var/www/frontend/pages/maintenance.vue?macro=true";
import { default as indexYD4sewD31hMeta } from "/var/www/frontend/pages/payments/index.vue?macro=true";
import { default as indexPNNFgR6xM5Meta } from "/var/www/frontend/pages/proposal/index.vue?macro=true";
import { default as registerInstructionsiVnM1MSeYQMeta } from "/var/www/frontend/pages/registerInstructions.vue?macro=true";
import { default as _91id_93vHc2dWuRZvMeta } from "/var/www/frontend/pages/services/[id].vue?macro=true";
import { default as indexVztH9ns3nsMeta } from "/var/www/frontend/pages/services/index.vue?macro=true";
import { default as indexO5M6Oy8gzZMeta } from "/var/www/frontend/pages/termsAndRules/index.vue?macro=true";
import { default as test_45consultations_45debugYvAVNFn2hkMeta } from "/var/www/frontend/pages/test-consultations-debug.vue?macro=true";
import { default as _91id_93EQMkxfaxRZMeta } from "/var/www/frontend/pages/user-activation/[id].vue?macro=true";
export default [
  {
    name: index0ZkXB1Z1gRMeta?.name,
    path: "/paskyra",
    meta: index0ZkXB1Z1gRMeta || {},
    component: () => import("/var/www/frontend/pages/account/index.vue").then(m => m.default || m),
    children: [
  {
    name: "account-index-account-management___lt",
    path: "paskyros-valdymas",
    meta: account_45managementwCZWutpaveMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/account-management.vue").then(m => m.default || m)
  },
  {
    name: "account-index-change-password___lt",
    path: "slaptazodzio-keitimas",
    meta: change_45passwordvkA2IxLHzoMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-index-danger-zone___lt",
    path: "pavojinga-zona",
    meta: danger_45zoneCuR3rMNG59Meta || {},
    component: () => import("/var/www/frontend/pages/account/index/danger-zone.vue").then(m => m.default || m)
  },
  {
    name: "account-index-firm___lt",
    path: "kontora",
    meta: firmcP6QLPRS2dMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/firm.vue").then(m => m.default || m)
  },
  {
    name: "account-index___lt",
    path: "",
    meta: indexkD7KexlZSbMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/index.vue").then(m => m.default || m)
  },
  {
    name: "account-index-profile___lt",
    path: "profilis",
    meta: profileMMpqe0U411Meta || {},
    component: () => import("/var/www/frontend/pages/account/index/profile.vue").then(m => m.default || m)
  },
  {
    name: "account-index-workHours___lt",
    path: "darbo-laikas",
    meta: workHoursKjumUaHlKJMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/workHours.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index0ZkXB1Z1gRMeta?.name,
    path: "/en/account",
    meta: index0ZkXB1Z1gRMeta || {},
    component: () => import("/var/www/frontend/pages/account/index.vue").then(m => m.default || m),
    children: [
  {
    name: "account-index-account-management___en",
    path: "account-management",
    meta: account_45managementwCZWutpaveMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/account-management.vue").then(m => m.default || m)
  },
  {
    name: "account-index-change-password___en",
    path: "change-password",
    meta: change_45passwordvkA2IxLHzoMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/change-password.vue").then(m => m.default || m)
  },
  {
    name: "account-index-danger-zone___en",
    path: "danger-zone",
    meta: danger_45zoneCuR3rMNG59Meta || {},
    component: () => import("/var/www/frontend/pages/account/index/danger-zone.vue").then(m => m.default || m)
  },
  {
    name: "account-index-firm___en",
    path: "firm",
    meta: firmcP6QLPRS2dMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/firm.vue").then(m => m.default || m)
  },
  {
    name: "account-index___en",
    path: "",
    meta: indexkD7KexlZSbMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/index.vue").then(m => m.default || m)
  },
  {
    name: "account-index-profile___en",
    path: "profile",
    meta: profileMMpqe0U411Meta || {},
    component: () => import("/var/www/frontend/pages/account/index/profile.vue").then(m => m.default || m)
  },
  {
    name: "account-index-workHours___en",
    path: "work-hours",
    meta: workHoursKjumUaHlKJMeta || {},
    component: () => import("/var/www/frontend/pages/account/index/workHours.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "action___lt",
    path: "/action",
    component: () => import("/var/www/frontend/pages/action/index.vue").then(m => m.default || m)
  },
  {
    name: "action___en",
    path: "/en/action",
    component: () => import("/var/www/frontend/pages/action/index.vue").then(m => m.default || m)
  },
  {
    name: "action-meeting-id___lt",
    path: "/veiksmas/susitikimas/:id()",
    meta: _91id_93GijVTgukJoMeta || {},
    component: () => import("/var/www/frontend/pages/action/meeting/[id].vue").then(m => m.default || m)
  },
  {
    name: "action-meeting-id___en",
    path: "/en/action/meeting/:id()",
    meta: _91id_93GijVTgukJoMeta || {},
    component: () => import("/var/www/frontend/pages/action/meeting/[id].vue").then(m => m.default || m)
  },
  {
    name: "action-payment___lt",
    path: "/veiksmas/mokejimas",
    component: () => import("/var/www/frontend/pages/action/payment.vue").then(m => m.default || m)
  },
  {
    name: "action-payment___en",
    path: "/en/action/payment",
    component: () => import("/var/www/frontend/pages/action/payment.vue").then(m => m.default || m)
  },
  {
    name: "appointment-firmLawyerId___lt",
    path: "/rezervacija/:firmLawyerId()",
    meta: _91firmLawyerId_93DdWlGWAZpkMeta || {},
    component: () => import("/var/www/frontend/pages/appointment/[firmLawyerId].vue").then(m => m.default || m)
  },
  {
    name: "appointment-firmLawyerId___en",
    path: "/en/appointment/:firmLawyerId()",
    meta: _91firmLawyerId_93DdWlGWAZpkMeta || {},
    component: () => import("/var/www/frontend/pages/appointment/[firmLawyerId].vue").then(m => m.default || m)
  },
  {
    name: "firm-slug___lt",
    path: "/kontora/:slug()",
    component: () => import("/var/www/frontend/pages/firm/[slug].vue").then(m => m.default || m)
  },
  {
    name: "firm-slug___en",
    path: "/en/firm/:slug()",
    component: () => import("/var/www/frontend/pages/firm/[slug].vue").then(m => m.default || m)
  },
  {
    name: "forLawyer___lt",
    path: "/teisininkui",
    component: () => import("/var/www/frontend/pages/forLawyer.vue").then(m => m.default || m)
  },
  {
    name: "forLawyer___en",
    path: "/en/for-lawyer",
    component: () => import("/var/www/frontend/pages/forLawyer.vue").then(m => m.default || m)
  },
  {
    name: "index___lt",
    path: "/",
    component: () => import("/var/www/frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "lawyer-slug___lt",
    path: "/teisininkas/:slug()",
    component: () => import("/var/www/frontend/pages/lawyer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "lawyer-slug___en",
    path: "/en/lawyer/:slug()",
    component: () => import("/var/www/frontend/pages/lawyer/[slug].vue").then(m => m.default || m)
  },
  {
    name: "lawyerCalendar-firmLawyerId___lt",
    path: "/teisininko-kalendorius/:firmLawyerId()",
    component: () => import("/var/www/frontend/pages/lawyerCalendar/[firmLawyerId].vue").then(m => m.default || m)
  },
  {
    name: "lawyerCalendar-firmLawyerId___en",
    path: "/en/lawyer-calendar/:firmLawyerId()",
    component: () => import("/var/www/frontend/pages/lawyerCalendar/[firmLawyerId].vue").then(m => m.default || m)
  },
  {
    name: "lawyers-specialty___lt",
    path: "/teisininkai/:specialty()",
    component: () => import("/var/www/frontend/pages/lawyers/[specialty].vue").then(m => m.default || m)
  },
  {
    name: "lawyers-specialty___en",
    path: "/en/lawyers/:specialty()",
    component: () => import("/var/www/frontend/pages/lawyers/[specialty].vue").then(m => m.default || m)
  },
  {
    name: "leaveReview-id___lt",
    path: "/palikti-atsiliepima/:lawyerId()",
    meta: _91id_93hRb0Ju4hQaMeta || {},
    component: () => import("/var/www/frontend/pages/leaveReview/[id].vue").then(m => m.default || m)
  },
  {
    name: "leaveReview-id___en",
    path: "/en/leave-review/:lawyerId()",
    meta: _91id_93hRb0Ju4hQaMeta || {},
    component: () => import("/var/www/frontend/pages/leaveReview/[id].vue").then(m => m.default || m)
  },
  {
    name: "login___lt",
    path: "/prisijungimas",
    component: () => import("/var/www/frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/var/www/frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "maintenance___lt",
    path: "/maintenance",
    meta: maintenanceFdVXnnEBbQMeta || {},
    component: () => import("/var/www/frontend/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    meta: maintenanceFdVXnnEBbQMeta || {},
    component: () => import("/var/www/frontend/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: "payments___lt",
    path: "/mokejimas",
    component: () => import("/var/www/frontend/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___en",
    path: "/en/payments",
    component: () => import("/var/www/frontend/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "proposal___lt",
    path: "/pasiulymas",
    component: () => import("/var/www/frontend/pages/proposal/index.vue").then(m => m.default || m)
  },
  {
    name: "proposal___en",
    path: "/en/proposal",
    component: () => import("/var/www/frontend/pages/proposal/index.vue").then(m => m.default || m)
  },
  {
    name: "registerInstructions___lt",
    path: "/registracijos-instrukcija",
    component: () => import("/var/www/frontend/pages/registerInstructions.vue").then(m => m.default || m)
  },
  {
    name: "registerInstructions___en",
    path: "/en/register-instructions",
    component: () => import("/var/www/frontend/pages/registerInstructions.vue").then(m => m.default || m)
  },
  {
    name: "services-id___lt",
    path: "/paslaugos/:id()",
    meta: _91id_93vHc2dWuRZvMeta || {},
    component: () => import("/var/www/frontend/pages/services/[id].vue").then(m => m.default || m)
  },
  {
    name: "services-id___en",
    path: "/en/services/:id()",
    meta: _91id_93vHc2dWuRZvMeta || {},
    component: () => import("/var/www/frontend/pages/services/[id].vue").then(m => m.default || m)
  },
  {
    name: "services___lt",
    path: "/paslaugos",
    meta: indexVztH9ns3nsMeta || {},
    component: () => import("/var/www/frontend/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: "services___en",
    path: "/en/services",
    meta: indexVztH9ns3nsMeta || {},
    component: () => import("/var/www/frontend/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: "termsAndRules___lt",
    path: "/taisykles-ir-nuostatos",
    component: () => import("/var/www/frontend/pages/termsAndRules/index.vue").then(m => m.default || m)
  },
  {
    name: "termsAndRules___en",
    path: "/en/terms-and-rules",
    component: () => import("/var/www/frontend/pages/termsAndRules/index.vue").then(m => m.default || m)
  },
  {
    name: "test-consultations-debug___lt",
    path: "/test-consultations-debug",
    component: () => import("/var/www/frontend/pages/test-consultations-debug.vue").then(m => m.default || m)
  },
  {
    name: "test-consultations-debug___en",
    path: "/en/test-consultations-debug",
    component: () => import("/var/www/frontend/pages/test-consultations-debug.vue").then(m => m.default || m)
  },
  {
    name: "user-activation-id___lt",
    path: "/vartotojo-aktyvavimas/:id()",
    component: () => import("/var/www/frontend/pages/user-activation/[id].vue").then(m => m.default || m)
  },
  {
    name: "user-activation-id___en",
    path: "/en/user-activation/:id()",
    component: () => import("/var/www/frontend/pages/user-activation/[id].vue").then(m => m.default || m)
  }
]